var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 -9.61651e-07C4.92487 -1.49276e-06 1.49276e-06 4.92487 9.61651e-07 11C4.30546e-07 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 -4.30546e-07 11 -9.61651e-07Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4218 11.5322L18.1288 10.8252L14.716 7.4126L12.3232 5.0195L11.3032 4L10.5962 4.707L11.616 5.7267L8.92378 8.4189L8.34318 7.8379C8.19568 7.6904 7.80558 7.2979 7.27678 7.5576L4.66698 8.8457C4.29728 9.0205 4.07418 9.4346 4.01708 9.7666C3.96088 10.0908 4.04488 10.3926 4.24708 10.5937L7.62308 13.9702C6.75708 14.9514 4.53748 17.4653 4.44868 17.5669L4.31608 17.7171L4.58128 17.9823L4.73148 17.8497L8.32828 14.6754L11.7051 18.0526C11.8794 18.2264 12.1143 18.3192 12.3692 18.3192C12.44 18.3192 12.5118 18.3124 12.5845 18.2977C12.9522 18.2254 13.2637 17.9823 13.3985 17.661L14.6002 14.7831C14.7945 14.287 14.4225 13.9169 14.2643 13.7587L13.7101 13.204L16.4022 10.5123L17.4218 11.5322ZM15.6948 9.8057L12.2959 13.2041L13.5576 14.4668C13.5727 14.4814 13.5981 14.5068 13.6216 14.5322L12.4785 17.2695C12.4648 17.291 12.4175 17.3134 12.3847 17.3183L4.99948 9.9668C4.99408 9.9092 5.05558 9.7793 5.10198 9.7461L7.60248 8.5117C7.61228 8.5215 7.62348 8.5322 7.63618 8.5449L8.92378 9.833L12.323 6.4338L14.009 8.1197L15.6948 9.8057Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinningIcon);
export default __webpack_public_path__ + "static/media/Pinning_icon.de7d65ccdd94352707bb8690a6f7b19e.svg";
export { ForwardRef as ReactComponent };